<template>
    <div v-if="!isLoggedIn" :class="!onlyText ? 'disclaimer-container' : ''">
      <p class="disclaimer-text">
        <strong v-if="!onlyText">Info:</strong> Already purchased from us?
        <a href="#" @click="handleLoginClick">Log in</a> to get additional 15% loyalty discount on your next purchase.
      </p>
    </div>
</template>
  
  <script setup>
  import { computed } from 'vue';
  import { useUserStore } from '~/store/userStore';
  import { useUIStore } from '~/store/uiStore';
  import { ModalTypes } from '~/types/enums'; // Import the enum ModalTypes
  
  const userStore = useUserStore();
  const uiStore = useUIStore();
  const isLoggedIn = computed(() => userStore.userData?.is_logged_in || false);
  
  const props = defineProps({
    onlyText: {
      type: Boolean,
      default: false
    }
  });
  
  const handleLoginClick = (event) => {
    event.preventDefault(); // Prevent the default anchor behavior
    uiStore.setModalType(ModalTypes.LOGIN);
  };
  </script>